/* eslint-disable */
import axios, { AxiosError } from 'axios';
import http from './http';

class LeavepageService {
  static getLeaveBalance(p0?: { userId: string; companyId: string }) {
    return http.get('/leave/balance-effective', {
      params: p0,
    });
  }

  static submitLeave(formData: FormData) {
    return http
      .post('/leave/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err) && err.response) {
          throw new Error(err.response.data?.message || 'An error occurred while submitting the leave request.');
        } else {
          throw err;
        }
      });
  }

  static reSubmitLeave(leaveId: string, formData: FormData) {
    const entries = Array.from(formData.entries());

    return http
      .patch(`/leave/update/${leaveId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err) && err.response?.data) {
          throw new Error((err.response.data as any)?.message || 'Re-submit failed.');
        }
        throw new Error(err.message || 'Re-submit failed.');
      });
  }

  static updateLeaveRecord(id: string, data: any) {
    return http
      .patch(`/leave/update/${id}`, data)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err) && err.response?.data) {
          throw new Error((err.response.data as any)?.message || 'An error occurred while updating the leave record.');
        } else {
          throw err;
        }
      });
  }

  static getLeaveRecords() {
    return http
      .get('/leave/mine')
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err) && err.response?.data) {
          throw new Error((err.response.data as any)?.message || 'An error occurred while fetching leave records.');
        } else {
          throw err;
        }
      });
  }

  static withdrawLeave(leaveId: string) {
    return http
      .patch(`/leave/withdraw/${leaveId}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err) && err.response?.data) {
          throw new Error((err.response.data as any)?.message || 'An error occurred while withdrawing the leave.');
        } else {
          throw err;
        }
      });
  }
}

export default LeavepageService;
